exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cb-block-context-menu {\n  min-width: 235px !important;\n  width: auto;\n}\n", ""]);

// exports
